import React from 'react';
import './Terms.scss'

function Terms() {
  return (
      <div id='terms'>
          <h1>Terms of Service</h1>
          <p>Last updated: January 29, 2022</p>
          <p>These terms and conditions (The “Terms and Conditions'') govern the use of capncovers.com. (the site). This site is operated by the owners of capncovers. This site is for the use of sports handicapping and sports betting picks. </p>
          <p>By using this Site, you indicate that you have read and understand these Terms and Conditions and agree to abide by them at all times. </p>
          
          <div className='legalContainer'>
            <h2>Interpretation and Definitions</h2>
            <p>All content made available and published on our Site is the property of the owner’s of capncovers and the Site’s creators. This includes, but is not limited to images, texts, logos, documents, downloadable files, and anything that contributes to the composition of the capncovers Site.</p>
          </div>

          <div className='legalContainer'>
            <h2>Age Restrictions</h2>
            <p>You must be of legal sports betting age within your state, city, or county. By using the capncovers Site, users agree that they are of legal age. We do not assume any legal responsibility for false statements about age.</p>
          </div>

          <div className='legalContainer'>
            <h2>Acceptable Use</h2>
            <p>As a user of our Site, you agree to use our Site legally, not to use our site for illegal purposes, and not to:</p>
            <ul>
                <li>Harass or mistreat other users of our site</li>
                <li>Violate the rights of others on our site</li>
                <li>Violate the intellectual property rights of the Site owners or any third party to the Site.</li>
                <li>Hack into another user's account on the site</li>
                <li>Act in any way or manner that could be deemed fraudulent</li>
                <li>Share your or another user’s account or account information</li>
                <li>Post any material that may be deemed inappropriate or offensive</li>
            </ul>
            <p>If we believe you are using our Site illegally or in any manner that violates these Terms and Conditions, we reserve the right to limit, suspend, or terminate your access to our Site. We also reserve the right to take any legal steps necessary to prevent you from accessing our Site. </p>
          </div>

          <div className='legalContainer'>
              <h2>Accounts</h2>
              <p>When you create an account on our Site, you agree to the following:</p>
              <ul>
                  <li>You are solely responsible for your account and the security and privacy of your account, including passwords or sensitive information attached to your account; and</li>
                  <li>All personal information you provide to us through your account is up to date, accurate, and truthful and you will update your information if it changes. </li>
              </ul>
              <p>We reserve the right to suspend or terminate your account if you are using our Site illegally  or if you violate these Terms and Conditions. </p>
          </div>

          <div className='legalContainer'>
              <h2>Sale of goods and services</h2>
              <p>The following goods and/or services are available on our Site: Advice for Sports Betting Picks.</p>
              <p>The services will be paid in full prior to receiving the information.</p>
              <p>These Terms and Conditions apply to all the goods and services that are displayed on our Site at the time you access it. This includes all products listed as being out of stock. All information, descriptions, or images that we provide about our goods and services are as accurate as possible. However, we are not legally bound by such information, descriptions, or images as we cannot guarantee the accuracy of all goods and services we provide. You agree to purchase goods and services from our Site at your own risk.</p>
              <p>We reserve the right to modify, reject or cancel your order whenever it becomes necessary. </p>
          </div>

          <div className='legalContainer'>
              <h2>Subscriptions</h2>
              <p>Your subscription automatically renews and you will be automatically billed until we receive notification that you want to cancel the subscription. </p>
              <p>To cancel your subscription, please follow the steps: cancel anytime.</p>
          </div>

          <div className='legalContainer'>
              <h2>Payments</h2>
              <p>All payments will be made through Stripe.</p>
              <p>We accept the following payment methods on our Site:</p>
              <ul>
                  <li>Credit Card</li>
                  <li>Debit Card</li>
              </ul>
              <p>When you provide us with your payment information, you authorize our use of and access to the payment instrument you have chosen to use. By providing us with your payment information, you authorize us to charge the amount due to this payment instrument.</p>
              <p>If we believe your payment has violated any law or these Terms and Conditions, we reserve the right to cancel or reverse your transaction.</p>
          </div>

          <div className='legalContainer'>
              <h2>Refunds</h2>
              <p>Refunds will only be given for reasons stated above, if your transaction has violated any law or these Terms and Conditions, we reserve the right to cancel or reverse your transaction. </p>
              <p>No refunds will be issued for our products, if one of our products has a guarantee, you will be issued a credit equal to the amount of your transaction which can be used on our Site and our Site only. It is your responsibility and yours alone to manage your subscription and your account. </p>
          </div>

          <div className='legalContainer'>
              <h2>Consumer Protection Law</h2>
              <p>Where any consumer protection legislation in your jurisdiction applies and cannot be excluded, these Terms and Conditions will not limit your legal right and remedies under that legislation. These Terms and Conditions will be read subject to the mandatory provisions of that legislation. If there is conflict between these Terms and Conditions and that legislation the mandatory provisions of the legislation will apply.</p>
          </div>

          <div className='legalContainer'>
              <h2>Limitations of Liability</h2>
              <p>Capncovers and our directors, officers, agents, employees, subsidiaries, and affiliates will not be liable for any actions, claims, losses, damages, liabilities and expenses including legal fees from your use of the Site. </p>
          </div>

          <div className='legalContainer'>
              <h2>Indemnity</h2>
              <p>Except where prohibited by law, by using this Site you indemnify and hold harmless capncovers and our directors, officers, agents, employees, subsidiaries, and affiliates from any actions, claims, losses, damages, liabilities and expenses including legal fees arising out of your use of our Site or your violation of these Terms and Conditions.</p>
          </div>

          <div className='legalContainer'>
              <h2>Severability</h2>
              <p>If at any time any of the provisions set forth in these Terms and Conditions are found to be inconsistent or invalid under applicable laws, those provisions will be deemed void and will be removed from these Terms and Conditions. All other provisions will not be affected by the removal and the rest of these Terms and Conditions will still be considered valid.</p>
          </div>

          <div className='legalContainer'>
              <h2>Changes</h2>
              <p>These Terms and Conditions may be amended from time to time in order to maintain compliance with the law and to reflect any changes to the way we operate our Site and the way we expect users to behave on our Site. We will notify users by email of changes to these Terms and Conditions or post a notice on our Site. </p>
          </div>

          <div className='legalContainer'>
              <h2>Contact Details</h2>
              <p>Email: capncovers@gmail.com </p>
              <p>You may also contact us on our Site by clicking the “message us” button located at the bottom right corner of our site.</p>
          </div>
      </div>
  );
}

export default Terms;
